module.exports = __webpack_public_path__ + "img/calls-blue.a792c9c2.png";